import React from 'react';
import { Banner } from './Banner';
import CarouselIcon from '../../assets/carousel-icon.svg';

export const TrainingAcademyBanner = (): JSX.Element => {
    return (
        <Banner
            title="Take your team’s performance to the next level!"
            description={[
                'Boost driving skills and technical expertise with Kalmar Training Academy specialized training courses, designed to keep your team & equipment safe and reliable.',
            ]}
            buttonText="Learn more"
            buttonLink="https://www.kalmarglobal.com/4a876f/globalassets/media/589840/589840_KALMAR---Driver-Training-Brochure-A5-lr-web.pdf.pdf"
            image="https://mykalmar-public-content.s3.eu-west-1.amazonaws.com/training_academy_banner_photo.png"
            Icon={CarouselIcon}
        />
    );
};
